import {ChangeDetectorRef, Component} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {ElementRef} from '@angular/core';
import {SubFormComponent} from '../../_subform';

/*
* Блок с удостоверениями НК
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-certificates-nk',
    templateUrl: './specialist-form-fields-certificates-nk.component.html'
})
export class SpecialistFormFieldsCertificatesNkComponent extends SubFormComponent {

    public formGroupTemplate = this._fb.group({
        certificate_nk: this._fb.array([]), // Это будет массив форм из компонента certificate-nk (Удостоверение НК)
    });

    constructor(public elementRef: ElementRef,
                private _fb: FormBuilder) {
        super();
    }
}
